import axios from 'axios';
import OperationModality from '../entity/operation-modality.entity';

export default class OperationModalityService {
  public static getOperationModalities(): Promise<OperationModality[]> {
    return axios.get('/api/operation-modalities').then(({ data }) => OperationModality.ofList(data));
  }
}
